import React, {  useContext, useCallback } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { NavPage } from '../../../services/NavService';
import { IInteriorMaterial2, InteriorMaterialClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { useState2 } from '../../../util/useState2';
import { GenericEditor } from '../GenericEditor';
import { SingleInteriorMaterialEditor } from './SingleInteriorMaterialEditor';

export function InteriorMaterialEditor(props: {

}) {

    const tc = useContext(TranslationContext);
    const client = useClient(InteriorMaterialClient);
    const selectedTranslationIndex = useState2(0);
    const getterFunc = useCallback(
        () => client.getInteriorMaterials().then(response => response.interiorMaterials),
        [client]
    );

    function editorFunc(mat: IInteriorMaterial2, onChange: () => void, updateCount: number) {
        return (
            <SingleInteriorMaterialEditor key={`${updateCount} ${mat.id}`}
                onChange={onChange}
                material={mat}
                selectedTranslationIndex={selectedTranslationIndex}
            />
        );
    }

    async function createNew(): Promise<number> {
        return await client.createNew();
    }

    return (
        <GenericEditor<IInteriorMaterial2>
            getterFunc={getterFunc}
            nameFunc={im => im.defaultName}
            navPage={NavPage.Admin.InteriorMaterial}
            className="interior-material-editor"
            editorFunc={editorFunc}
            newHandler={{
                buttonName: tc.translator("admin interior material new material button", "Nyt materiale..."),
                onClick: createNew
            }}
        />
    );
}
